export const lightenColour = (color, percent) => {
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i.test(color)) {
        return color;
    }
    const clampedPercent = Math.min(100, Math.max(0, percent));
    const num = parseInt(color.substring(1), 16), amt = Math.round(2.55 * clampedPercent), R = (num >> 16) + amt, B = ((num >> 8) & 0x00ff) + amt, G = (num & 0x0000ff) + amt;
    return "#" + (0x1000000 + (R < 255 ? R : 255) * 0x10000 + (B < 255 ? B : 255) * 0x100 + (G < 255 ? G : 255)).toString(16).slice(1);
};
